import checkAuthSaga from './check';
import loginSaga from './login';
import logoutSaga from './logout';
import resetPasswordSaga from './resetPassword';
import setNewPasswordSaga from './setNewPassword';
import acceptInvitationSaga from './acceptInvitation';

export default [checkAuthSaga, loginSaga, logoutSaga, resetPasswordSaga, setNewPasswordSaga, acceptInvitationSaga];
